"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkSurveyQuestionAggregateUpdatedSchema = exports.TrendValues = exports.BenchmarkValues = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
var BenchmarkValues;
(function (BenchmarkValues) {
    BenchmarkValues["MUCH_LOWER"] = "MUCH_LOWER";
    BenchmarkValues["LOWER"] = "LOWER";
    BenchmarkValues["SIMILAR"] = "SIMILAR";
    BenchmarkValues["HIGHER"] = "HIGHER";
    BenchmarkValues["MUCH_HIGHER"] = "MUCH_HIGHER";
})(BenchmarkValues || (exports.BenchmarkValues = BenchmarkValues = {}));
var TrendValues;
(function (TrendValues) {
    TrendValues["LESS_FAVORABLE"] = "LESS_FAVORABLE";
    TrendValues["SIMILAR"] = "SIMILAR";
    TrendValues["MORE_FAVORABLE"] = "MORE_FAVORABLE";
})(TrendValues || (exports.TrendValues = TrendValues = {}));
const QuestionChoiceAggregatePayload = zod_1.z.object({
    questionChoiceId: zod_1.z.string().uuid(),
    rawValue: zod_1.z.number(),
    weightedValue: zod_1.z.number().nullish(),
});
const QuestionTrendAggregatePayload = zod_1.z.object({
    weightedValue: zod_1.z.number(),
    recordedDate: zod_1.z.string().datetime(),
    trendValue: zod_1.z.nativeEnum(TrendValues).nullish(),
});
const QuestionAggregatePayload = zod_1.z.object({
    questionId: zod_1.z.string().uuid(),
    weightedValue: zod_1.z.number(),
    benchmarkComparison: zod_1.z.nativeEnum(BenchmarkValues),
    benchmarkSignificance: zod_1.z.number().int(),
    trendValue: zod_1.z.nativeEnum(TrendValues),
    trendSignificance: zod_1.z.number().int(),
    benchmarkRank: zod_1.z.number().int(),
    rankTotal: zod_1.z.number().int(),
    benchmarkDateStart: zod_1.z.string().datetime(),
    benchmarkDateEnd: zod_1.z.string().datetime(),
    topic: zod_1.z.string(),
    category: zod_1.z.string().nullish(),
    surveyId: zod_1.z.string().uuid(),
    questionChoiceAggregates: zod_1.z.array(QuestionChoiceAggregatePayload),
    questionTrendAggregates: zod_1.z.array(QuestionTrendAggregatePayload),
});
exports.BenchmarkSurveyQuestionAggregateUpdatedSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.MessageType.QuestionAggregates.Updated),
    version: zod_1.z.string(),
    payload: zod_1.z.object({
        questions: zod_1.z.array(QuestionAggregatePayload),
    }),
});
